/*
 * @author: xd
 * @Date: 2021-12-16 21:24:52
 * @LastEditors: xd
 * @LastEditTime: 2022-06-25 14:10:10
 * @Description: 功能
 */
import { BaseClass } from "../base/DreamScape";
import { AxiosRequestConfig } from "axios";
import { Axios, IActionData, IActionUploadData, IActionDelData } from "./Axios";

export class DataClass extends BaseClass {
  axios: Axios;
  private _appid: string;
  private _pid: string;
  private _url: string;
  constructor(pro:any) {
    super();
    this.axios = new Axios();
    this._url=pro.url;
    this._pid=pro.pid;
    this._appid=pro.appid;
  }

  /**
   * @description: 添加数据，默认已带参数CID=5000
   * @param {any} actionData JSON参数
   * @return {*}
   */
  AddSingleData(actionData: any): any {
    let mActionData: IActionData = actionData;
    mActionData.XDLMCID = "5000";
    return this.axios.PostData(this._url,this._pid, "GetDataInterface", mActionData);
  }

  /**
   * @description: 添加批量数据，默认已带参数CID=5001
   * @param {any} actionData  示例actionData=
   * {
   *      XDLMSID: sid,
   *      datalist: JSON.stringify({ "key": dataArr })
   *  }
   * dataArr={XDLMA:111,XDLMB:222}
   * @return {*}
   */
  AddBatchData(actionData: any): any {
    let mActionData: IActionData = actionData;
    mActionData.XDLMCID = "5001";
    // var returnData = this.PostDataA("GetDataInterface", {
    //     XDLMCID: "5001",
    //     XDLMSID: sid,
    //     datalist: JSON.stringify({ "key": dataArr })
    // });
    return this.axios.PostData(this._url,this._pid, "GetDataInterface", mActionData);
  }

  /**
   * @description: 数据更新 默认已带参数CID=6000，必须【XDLMID==id】
   * @param {any} actionData
   * @return {*}
   */
  updateData(actionData: any): any {
    let mActionData: IActionData = actionData;
    mActionData.XDLMCID = "6000";
    let err = "";
   let isId=false;
      for (var key in mActionData) {
        if (key.indexOf("XDLMID") != -1) {
          isId=true;
        }
        if (key.indexOf("XDLM") == -1) {
          err += "提交属性：【"+key+"】缺少XDLM。";
        }
        if (key.indexOf("xmbh") != -1) {
          err += "编辑时不允许包含【xmbh】。";
        }
        if (key.indexOf("项目编号") != -1) {
          err += "编辑时不允许包含【项目编号】。";
        }
        if (key.indexOf("库内编号") != -1) {
          err += "编辑时不允许包含【库内编号】。";
        }
        if (err != "") {
          break;
        }
      }
      if(!isId)
      {
        err += "缺少XDLMID。";
      }
     
    if (err != "") {
      return Promise.reject({
        success: false,
        message: err,
      });
    } else {
      return this.axios.PostData(this._url,
        this._pid,
        "GetDataInterface",
        mActionData
      );
    }
  }

  /**
   * @description: 数据删除 默认已带参数CID=6000，必须表单【XDLMROWID==id】也可多个用逗号隔开
   * @param {any} actionData
   * @return {*}
   */
  delData(actionData: any): any {
    try {
      let mActionData: IActionDelData = actionData;
      mActionData.XDLMCID = "4000";
      return this.axios.PostData(this._url,
        this._pid,
        "GetDataInterface",
        mActionData
      );
    } catch (e) {
      return e;
    }
  }

  /**
   * @description: 获取单条数据 默认已带参数CID=1001，参数必须带XDLMID
   * @param {any} actionData
   * @return {*}
   */
  getSingleData(actionData: any): any {
    let mActionData: IActionData = actionData;
    mActionData.XDLMCID = "1001";
    return this.axios.PostData(this._url,this._pid, "GetDataInterface", mActionData);
  }

  /**
   * @description: 获取多条数据 默认已带参数CID=1001，
   * @param {any} actionData
   * @return {*}
   */
  getListData(actionData: any): any {
    let mActionData: IActionData = actionData;
    if (!mActionData.XDLMCID) {
      mActionData.XDLMCID = "1001";
    }

    return this.axios.PostData(this._url,this._pid, "GetDataInterface", mActionData);
  }

    /**
   * @description: 获取多条数据 默认已带参数CID=1001，
   * @param {any} actionData
   * @return {*}
   */
     getListDataByAppID(actionData: any): any {
      let mActionData: IActionData = actionData;
      if (!mActionData.XDLMCID) {
        mActionData.XDLMCID = "1001";
      }
  
      return this.axios.PostDataByID(this._url,this._pid, "GetDataInterface", mActionData,this._appid);
    }

  /**
   * @description: 获取树形列表数据 默认已带参数CID=2000
   * @param {any} actionData
   * @return {*}
   */
  getTreeData(actionData: any): any {
    let mActionData: IActionData = actionData;
    mActionData.XDLMCID = "2000";
    return this.axios.PostData(this._url,this._pid, "GetDataInterface", mActionData);
  }

  /**
   * @description: 获取统计数据 默认已带参数CID=8000
   * @param {any} actionData
   * @return {*}
   */
  getStatisticsData(actionData: any): any {
    let mActionData: IActionData = actionData;
    mActionData.XDLMCID = "8000";
    return this.axios.PostData(this._url,this._pid, "GetDataInterface", mActionData);
  }

  /**
   * @description: 获取导出excel数据 默认已带参数CID=5002
   * @param {any} actionData
   * @return {*}
   */
  getExcelData(actionData: any): any {
    let mActionData: IActionData = actionData;
    mActionData.XDLMCID = "5002";
    return this.axios.PostData(this._url,this._pid, "GetDataInterface", mActionData);
  }

  /**
   * @description:
   * @param {string} 获取扩展API 适用CID=9000开头数据
   * @param {IActionData} mActionData
   * @return {*}
   */
  getExtendAPI(mActionType: string, mActionData: IActionData): any {
    return this.axios.PostData(this._url,this._pid, mActionType, mActionData);
  }

  /**
   * @description:获取json等文件
   * @param {string} url
   * @return {*}
   */
   getFile(url: string,config?:AxiosRequestConfig | undefined): any {
    return this.axios.getData(url,config);
  }

  /**
   * @description:
   * @param {string} 获取扩展API 适用CID=9000开头数据
   * @param {IActionUploadData} mActionData
   * @return {*}
   */
  uploadFile(mActionData: IActionUploadData, onUploadProgress?: any): any {
    mActionData.XDLMCID = "5003";
    return this.axios.uploadData(this._url,
      this._pid,
      "GetDataInterface",
      mActionData,
      onUploadProgress
    );
  }
}
